angular.module('bribac.components.testOverviewPopup', [
  'pascalprecht.translate',
  'bribac.values',
  'bribac.entities.kinds',
  'bribac.components.collapsingBox',
  'bribac.components.cardTestStatus',
  'bribac.components.testDetails'
])

  .component('testOverviewPopup', {
    templateUrl: 'test-overview-popup-component.html',
    controller: 'TestOverviewPopupCtrl',
    bindings: {
      resolve: '<',
        subject : '<',
      dismiss: '&'
    }
  })

  .controller('TestOverviewPopupCtrl', function(

  ) {
      this.$onInit = function() {
          console.log(this);
      };
  })
